module.exports = __webpack_public_path__ + "static/media/IconPayNow.74a8c840.png";